import { useState, useCallback, useMemo, useEffect } from "react";
import config from "../config/config";
import RightSidebar from "./RightSidebar";
import BottomBar from "./BottomBar";
import StepTabs from "./StepTabs";
import { useNavigate, useSearchParams } from "react-router-dom";
import "./TransactionDetail.css";
import { MemoizedManagerForm } from "./forms/manager/managerForm";
import { SubHeadWithButton } from "./ui/subHeadWithButton";
import { v4 as uuidv4 } from "uuid";
import { sharedData } from "../sharedData/sharedData";
import { managementStructureService } from "../requests/managementStrcutureService";
import { ManagementStructureFactory } from "../factory/managementStrcutureFactory";
import { useValidateManagementStructure } from "../validations/validationHooks/useValidateManagementStructure";
import { diligenceObservable } from "../observers/deligenceObservable";
import {FetchDetailErrorMessage,SaveFailureMessage,SaveResultMessages,SaveResponseMessage,ErrorMessage,ValidatingMessage,SavingMessage} from "../components/popups/allPopup";
import { handleAddressValidationManagers } from "../hooks/addressValidator";
import { useValidateSingleAddress } from "../hooks/validateSingleAddress";
import AddressUpdateConfirmationModal from "./ui/AddressUpdateConfirmationModal";
import { useModal } from "../hooks/useModal";
import { Modal } from "./ui/Modal";
import FloatingQueryCenter from "./FloatingQueryCenter";
import ConfirmationModal from "./ui/ConfirmationModal";
import DeleteConfirmationModal from "./ui/DeleteConfirmationModal";
import { Input } from "./ui/Input";
import MoreDetailsModal from "./forms/client-counterparty/MoreDetailsModal";
import ErrorModal from "./ui/ErrorModal";
import { getNextEnabledSection, getPreviousEnabledSection, isSectionSkipped } from "../utils/navigationHelper";
import { reloadAfterValidate } from "../utils/reloadAfterValidate";
import ViewModeBanner from "./ui/ViewModeBanner";
import { useTooltips } from "../hooks/toolTips";
import { Tooltip } from "react-tooltip";
import { FaInfoCircle } from "react-icons/fa";
import "react-tooltip/dist/react-tooltip.css";
const intialManagerState = {
  id: uuidv4(),
  managerType: "None",
  managerEntity: "",
  functionDetail: "",
  data: {}
}

export default function ManagementStructureForm({isReport}) {

  const navigate = useNavigate();

  const tooltips = useTooltips();
  const headingTooltip = useMemo(() => {
    const dummyTooltip =
      "This section captures the management/operational structure of the entity. " +
      "Add each manager and provide their role, identification documents, and other supporting details.";
    if (!Array.isArray(tooltips)) return dummyTooltip;
    const match = tooltips.find(
      (t) =>
        t.Label?.toLowerCase().trim() === "management structure" ||
        t.Name?.toLowerCase().trim() === "managementstructure"
    );
    const text = match?.Tooltip?.trim();
    if (!text || text.toLowerCase() === "123" || text.length < 7) return dummyTooltip;
    return text.replace(/\n/g, "<br/>");
  }, [tooltips]);

  const [isModalOpen, setIsModalOpen] = useState(false);
  const [errorModalOpen, setErrorModalOpen] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const [modalMessage, setModalMessage] = useState("");

  const [searchParams] = useSearchParams();
  const [hasUnsavedChanges, setHasUnsavedChanges] = useState(false);
  // [ ]: the initial state have no partners

  const requestId = useMemo(() => sharedData.get("requestId"), []);
  const transactionId = useMemo(() => sharedData.get("transactionId"), []);
  const propertyId = useMemo(() => sharedData.get("propertyId"), []);
  const entityId = useMemo(() => sharedData.get("entityId"), []);
  const status = useMemo(() => sharedData.get("status"), []);
  const [isReadOnly, setIsReadOnly] = useState(false);

  const [directors, setDirectors] = useState([""]); // Start with one empty director

  const isView = useMemo(() => searchParams.get("view") === "true", [searchParams]);
  const isEdit = useMemo(() => searchParams.get("edit") === "true", [searchParams]);

  const { validateManagementStructure } = useValidateManagementStructure();
  const [showDetailsModal, setShowDetailsModal] = useState(false);
const [modalData, setModalData] = useState(null);
const [modalType, setModalType] = useState("officer");
const [modalRawData, setModalRawData] = useState(null);
  const [managers, setManagers] = useState(()=>{
    const storedManagers = localStorage.getItem('managers');
    return storedManagers ? JSON.parse(storedManagers) : [];
  });

  // Seeded from the server statuses StepTabs primes, then owned by
  // getManagementStrcutureDetails. It used to be read straight off a
  // localStorage 'managersStatus' key, which was global rather than per-request and
  // could hold a stale value (or the string "undefined") from another deal — locking
  // or unlocking this page against what Final Review and the sign-off gate believed.
  const [managementStatus, setManagementStatus] = useState(
    () => (sharedData.get("sectionStatuses") || {}).management);
  const validated = managementStatus === "Validated";

  useEffect(() => {
      const isReadOnlyFromURL = searchParams.get("readonly") === "true";
      const isViewMode = searchParams.get("view") === "true";
      setIsReadOnly(isReadOnlyFromURL || isViewMode || validated);
    }, [validated, searchParams]);

  const [diligenceStatus, setDiligenceStatus] = useState(sharedData.get("diligenceStatus") || "");

  useEffect(() => {
    // Subscribe to diligence observable changes
    const subscription = diligenceObservable.subscribe(() => {
      setDiligenceStatus(sharedData.get("diligenceStatus") || "");
    });
    return () => subscription.unsubscribe();
  }, []);


const formatAddress = (address) => {
  if (!address) return '';
  
  const { address_line_1, country, locality, postal_code } = address;
  const parts = [address_line_1, country, `${locality} ${postal_code}`].filter(Boolean);
  return parts.join(', ');
};

const formatDateOfBirth = (dateOfBirth) => {
  if (!dateOfBirth || !dateOfBirth.month || !dateOfBirth.year) return '';
  
  return `${dateOfBirth.month}, ${dateOfBirth.year}`;
};

const handleGetOfficerDetails = async () => {
  try {
    const formData = localStorage.getItem("clientFormData");
    const companyId = JSON.parse(formData)?.registrationNumber;

    const res = await fetch(
      `${config["backend-url"]}/get_officer_details_more_fromlink`,
      {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ company_number: companyId }),
      }
    );

    const data = await res.json();
    if (!res.ok) throw new Error(data?.error || "Failed to fetch details");

    // Save raw items before transformation (needed for import)
    const rawItems = data.items ? [...data.items] : [];

    // Format addresses and date of birth, remove original objects
    if (data.items && Array.isArray(data.items)) {
      data.items = data.items.map(item => {
        const { address, date_of_birth, ...itemWithoutAddressAndDOB } = item;
        return {
          ...itemWithoutAddressAndDOB,
          DateOfBirth: formatDateOfBirth(date_of_birth),
          Address: formatAddress(address)
        };
      });
    }

    setModalData(data);
    setModalRawData(rawItems);
    setModalType("officer");
    setShowDetailsModal(true);

  } catch (err) {
    console.error("Fetch error:", err);
    setErrorMessage("Failed to fetch additional details.");
    setErrorModalOpen(true);
  }
};



  const handleImportOfficers = useCallback((rawItems) => {
    const roleMap = {
      "director": "Director",
      "secretary": "Company Secretary",
      "managing-director": "Managing Director",
      "llp-designated-member": "LLP Designated Member",
    };

    const activeOfficers = rawItems.filter(item => !item.resigned_on);

    const newManagers = activeOfficers.map(item => {
      const mappedRole = roleMap[item.officer_role?.toLowerCase()] || "Other";
      const addr = item.address || {};
      return {
        id: uuidv4(),
        managerType: mappedRole,
        managerEntity: "Individual",
        functionDetail: mappedRole === "Other" ? (item.officer_role || "") : "",
        data: {
          fullName: item.name || "",
          nationality: item.nationality || "",
          countryOfResidence: addr.country || "",
          addressLine1: addr.address_line_1 || "",
          addressLine2: addr.address_line_2 || "",
          city: addr.locality || "",
          postalCode: addr.postal_code || "",
          country: addr.country || "",
        }
      };
    });

    setManagers(prev => {
      const updated = [...prev, ...newManagers];
      localStorage.setItem('managers', JSON.stringify(updated));
      return updated;
    });

    setShowDetailsModal(false);
  }, []);

  const managerEntities = useMemo(() => managers.map(m => m.managerEntity), [managers]);

  const { validateSingleAddress } = useValidateSingleAddress();
  const [showManagerAddressModal, setShowManagerAddressModal] = useState(false);
  const [pendingUpdatedManagers, setPendingUpdatedManagers] = useState(null);
  const [managerValidationResult, setManagerValidationResult] = useState(null);
  const [modalHeading, setModalHeading] = useState("");
  const { modalOpen, setModalOpen } = useModal();
  const [currentManagerIndex, setCurrentManagerIndex] = useState(0);
  const [managerAddressChanges, setManagerAddressChanges] = useState([]);


  const checkIsReadOnly = useCallback((status) => {
      if (!status) return false; // Guard against undefined detail object
      const isTransactionCompleted = status === "Validated";
      // ?view must lock the form. Leaving it out meant this writer, running on fetch,
      // unlocked a page the URL had put in view mode — every other page counts it.
      const isReadOnlyFromURL = searchParams.get("readonly") === "true" || searchParams.get("view") === "true";
      setIsReadOnly(isTransactionCompleted || isReadOnlyFromURL)
      return isTransactionCompleted || isReadOnlyFromURL;
    },[searchParams])

  const getManagementStrcutureDetails = useCallback(async (entityId) => {
    try {
      const response = await managementStructureService.getManagementStrcutureByEntityId(entityId);
      if (response.ok) {
        const data = response.data;
        // console.log("Data: ", data[0].data);
        const managersData = ManagementStructureFactory(data[0].data);
        setManagementStatus(data[0].status);
        checkIsReadOnly(data[0].status);
        setManagers(managersData);
        localStorage.setItem('managers', JSON.stringify(managersData));
      } else if (response.status === 404) {
          // setModalMessage("Management structure not found for this entity, You can add a new one.")
          // setIsModalOpen(true);
      } else {
        setModalMessage(<FetchDetailErrorMessage page="management structure" />);
        // setIsModalOpen(true)
         setModalOpen(true);
      }
    } catch (error) {
      console.error("Error fetching management structure details:", error);
    }
  },[]);

  useEffect(()=>{
    if (isView || isEdit) {
      getManagementStrcutureDetails(sharedData.get("entityId"));
    } else {
      // if not present in localstorage, call from api
      const storedManagers = localStorage.getItem('managers');
      if (!storedManagers) {
        getManagementStrcutureDetails(sharedData.get("entityId"));
      }
    }
  },[getManagementStrcutureDetails, isView, isEdit]);

  const handleChange = useCallback((id, e) => {
    const { name, value } = e.target;
    setManagers((prev) => {
      const newData = prev.map((m)=>{
        if (m.id === id) {
            if (name === "managerType") {
              return {
                ...m,
                managerType: value,
                data: {}
              };
            } else if (name === "managerEntity") {
              return {
                ...m,
                managerEntity: value,
                data: value === "Corporate" ? { uboState: { type: '', percentage: '', data: {} } } : {}
              };
            } else if (name === "functionDetail") {
              return {
                ...m,
                functionDetail: value,
              }
            }else {
              return m;
            }
        } else {
          return m;
        }
      });
      localStorage.setItem('managers', JSON.stringify(newData));
      return newData;
    })
  }, []);


  // Handle adding a new director
  const addDirector = () => {
    setDirectors([...directors, ""]);
  };


  const checkHasErrors = useCallback((totalErrors) => {
      if (!totalErrors || totalErrors.length === 0) return false;
    
      for (let itemObject of totalErrors) {
        if (itemObject && Object.keys(itemObject).length > 0) {
          let keys = Object.keys(itemObject);
    
          // If there are keys other than 'nomieeErrors'
          const otherKeys = keys.filter((key) => key !== 'nomieeErrors');
          if (otherKeys.length > 0) {
            for (let key of otherKeys) {
              if (Array.isArray(itemObject[key]) && itemObject[key].length > 0) {
                return true;
              }
            }
          }
    
          // If only 'nomieeErrors' exists
          if ('nomieeErrors' in itemObject) {
            const nomieeErrors = itemObject.nomieeErrors;
            if (Array.isArray(nomieeErrors) && nomieeErrors.length > 0) {
              for (let nomiee of nomieeErrors) {
                if (nomiee && Object.keys(nomiee).length > 0) {
                  return true;
                }
              }
            }
          } else {
            // nomieeErrors key doesn't exist but object has something ⇒ return true
            return true;
          }
        }
      }
    
      return false;
    }, []);

  const handleValidate = async () => {
    let totalErrors = [];
    managers.forEach((manager) => {
      const errors = validateManagementStructure(manager);
      totalErrors.push(errors);
    });
      console.log("UBO Errors", totalErrors);
      const hasErrors = checkHasErrors(totalErrors);
      console.log("Has Errors", hasErrors);
      let flag = false;
      if (hasErrors) {
        setModalMessage(
          <>
            <h2 style={{ margin: "10px 0", textAlign: "center" }}>
              Validation Result
            </h2>
            <strong>Please fill in the following required fields:</strong>
            <br />
            <div style={{ maxHeight: "300px", overflow: "auto", padding: "10px" }}>
              {totalErrors.map((uboErrors, uboIndex) => (
                <div key={uboIndex} style={{ marginBottom: "15px" }}>
                  {Object.keys(uboErrors).length > 0 && (
                    <>
                      <strong>UBO {uboIndex + 1}:</strong>
                      <ul style={{ marginLeft: "20px" }}>
                        {Object.entries(uboErrors).map(([field, errors]) => { // nominee error of one ubo
                          if (field === "nomieeErrors") {
                            return (
                              errors && errors.length > 0 && errors.some(error=>error && Object.keys(error).length > 0) ? <li key={field}>
                                <strong>Nominees:</strong>
                                <ul style={{ marginLeft: "20px" }}>
                                  {errors.map((nomineeError, nomineeIndex) => (
                                    nomineeError && <li key={nomineeIndex}>
                                      <strong>Nominee {nomineeIndex + 1}:</strong>
                                      <ul style={{ marginLeft: "20px" }}>
                                        {nomineeError && Object.entries(nomineeError).map(
                                          ([nField, nErrors]) => (
                                            <li key={nField}>
                                              {nErrors.map((error, errorIndex) => (
                                                <div key={errorIndex}>{error}</div>
                                              ))}
                                            </li>
                                          )
                                        )}
                                      </ul>
                                    </li>
                                  ))}
                                </ul>
                              </li> : flag = true
                            );
                          }
                          return (
                            <li key={field}>
                              {errors.map((error, errorIndex) => (
                                <div key={errorIndex}>{error}</div>
                              ))}
                            </li>
                          );
                        })}
                      </ul>
                    </>
                  )}
                </div>
              ))}
            </div>
          </>
        );
        // setIsModalOpen(true);
         setModalOpen(true);
        return;
      }
      handleSave(true);

      getManagementStrcutureDetails(sharedData.get("entityId"));
      console.log("managers before add val:",managers)
      // ✅ Call handleAddressValidationManagers
      // ✅ Proceed with address validation
      // Check if all managers are already validated
      const allValidated = managers.every(
        (manager) => manager.validateAddressStatus === "Validated"
      );
  
      if (allValidated) {
        // Skip validation step and continue directly
        return false
      } else {
        // Proceed with validation if at least one is not validated
        const {
          valid,
          data: validatedFormData,
        } = await handleAddressValidationManagers({
          managers,
          setManagers,
          setModalOpen: setIsModalOpen,
          setModalHeading,
          setModalMessage,
          setManagerValidationResult,
          setPendingUpdatedManagers,
          setShowManagerAddressModal,
          validateSingleAddress,
          setManagerAddressChanges,
          setCurrentManagerIndex,
        });
  
        if (valid && validatedFormData) {
          const payload = {
            entityId: entityId,
            data: JSON.stringify(validatedFormData),
            status: "Validated",
          };
          setManagers(validatedFormData);
          console.log("managers after add val:", validatedFormData);
  
          const response = await managementStructureService.saveManagementStructure(payload);
          if (response.ok) {
            localStorage.setItem("managers", JSON.stringify(validatedFormData));
            setTimeout(() => {
              // setIsModalOpen(false);
               setModalOpen(false);
            }, 50);
            reloadAfterValidate(50);
            return true;
          } else {
            setModalMessage(
              <SaveResponseMessage type="error" message={response.data.error} />
            );
            // setIsModalOpen(true);
             setModalOpen(true);
            return false;
          }
        }
      }
  };

  const handleNext = () => {
    handleSave();

    // Check Client/Counterparty completion status
    const clientFormData = localStorage.getItem("clientFormData");
    let isClientCounterpartyCompleted = false;
    if (clientFormData) {
      const parsedData = JSON.parse(clientFormData);
      isClientCounterpartyCompleted = parsedData.entityStatus === "Validated" || parsedData.status === "Validated";
    }

    // Use navigation helper to determine next enabled section
    const nextPath = getNextEnabledSection('/management-structure', {
      isEntityIdMissing: !entityId,
      isClientCounterpartyCompleted,
      searchParams
    });

    navigate(nextPath, {
      state: { requestId, transactionId, entityId, propertyId },
    });
  }

  const handleBack = () => {
    // Check Client/Counterparty completion status
    const clientFormData = localStorage.getItem("clientFormData");
    let isClientCounterpartyCompleted = false;
    if (clientFormData) {
      const parsedData = JSON.parse(clientFormData);
      isClientCounterpartyCompleted = parsedData.entityStatus === "Validated" || parsedData.status === "Validated";
    }

    // Use navigation helper to determine previous enabled section
    const previousPath = getPreviousEnabledSection('/management-structure', {
      isEntityIdMissing: !entityId,
      isClientCounterpartyCompleted,
      searchParams
    });

    navigate(previousPath, {
      state: { requestId, transactionId, entityId, propertyId },
    });
  }

  const addManager = useCallback(() => {
    setManagers((prev) => {
      const newData = [
        ...prev,
        { ...intialManagerState, id: uuidv4() }
      ];
      localStorage.setItem('managers', JSON.stringify(newData));
      return newData;
    })
  }, []);

  const handleIndividualChange = useCallback((id, e) => {
    console.log(e.target.name, e.target.value);
    setManagers(prev => {
      const newData = prev.map(m => 
        m.id === id ? {
          ...m,
          data: {
            ...m.data,
            [e.target.name]: e.target.value
          }
        } : m
      );
      localStorage.setItem('managers', JSON.stringify(newData));
      return newData;
    });
  }, []);

  const handleUBOChange = useCallback((id, newUBOState) => {
    setManagers(prev => {
      const newData = prev.map(m => 
        m.id === id ? {
          ...m,
          data: { ...m.data, uboState: newUBOState }
        } : m
      );
      localStorage.setItem('managers', JSON.stringify(newData));
      return newData;
    });
  }, []);

  // const removeManager = useCallback((id) => {
  //   // eslint-disable-next-line no-restricted-globals
  //   const data = confirm("Are you sure you want to remove this manager?");
  //   if (data) {
  //     setManagers(prev => {
  //       const newData = prev.filter(m => m.id !== id);
  //       localStorage.setItem('managers', JSON.stringify(newData));
  //       return newData;
  //     });
  //   }
  // }, []);
 
const [selectedManagerId, setSelectedManagerId] = useState(null);

const removeManager = useCallback((id) => {
  setSelectedManagerId(id);
  setIsModalOpen(true);
}, []);

const handleConfirmRemove = () => {
  setManagers(prev => {
    const newData = prev.filter(m => m.id !== selectedManagerId);
    localStorage.setItem('managers', JSON.stringify(newData));
    return newData;
  });
  setIsModalOpen(false);
  setSelectedManagerId(null);
};


  const saveManagementStructure = useCallback(async (valid) => {
    console.log("managers in saveManagementStructure:",managers)

    const payload = {
      entityId: entityId,
      data: JSON.stringify(managers),
      status: valid ? "Validated" : validated ? "Validated" : "Not Validated",
    };
    try {
      const response = await managementStructureService.saveManagementStructure(payload);
      if (response.ok) {
        setModalMessage(<SaveResponseMessage type="success" message={response.data.message} />);
        // setIsModalOpen(true)
         setModalOpen(true);
       
        return true;
      } else {
     
        setModalMessage(<SaveResponseMessage type="error" message={response.data.error} />);
        // setIsModalOpen(true)
         setModalOpen(true);
        return false;
      }
    } catch (error) {
      
      setModalMessage(<ErrorMessage message={error.message} />);
      // setIsModalOpen(true)
       setModalOpen(true);

      return false;
    }
    
  }, [entityId, managers, validated]);

  const handleSave = useCallback(async (validated=undefined)=>{
    setHasUnsavedChanges(false);
    setModalMessage(
      validated
        ? <ValidatingMessage page="Management Structure" />
        : <SavingMessage page="Management Structure" />
    );
    const response = await saveManagementStructure(validated);
    if (response) {

      setModalMessage(<SaveResultMessages page="Management Structure" validated={validated} />);
      // setIsModalOpen(true)
       setModalOpen(true);
      getManagementStrcutureDetails(sharedData.get("entityId"));
    } else {
      setModalMessage(<SaveFailureMessage page="Management Structure" />);
      // setIsModalOpen(true)
       setModalOpen(true);
    }
  }, [
    getManagementStrcutureDetails,
    saveManagementStructure,
    managers,
  ]);

  

  return (
    <>
     
      <div className={!isReport ? "transaction-detail" : ""}>
        {!isReport && <StepTabs hasUnsavedChanges={hasUnsavedChanges} searchParams={searchParams} isEdd={diligenceObservable.isEnhanced()} />}
        <ViewModeBanner
          isReadOnly={isReadOnly}
          status={managementStatus}
        />
         <div className="form-section">
        <div className="transaction-form form_information">
           <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', width: '100%', }} >
          <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
            <h2 style={{ margin: 0 }}>Management Structure</h2>
            {headingTooltip && (
              <>
                <span
                  data-tooltip-id="tooltip-managementStructureHeading"
                  style={{ cursor: 'pointer', display: 'inline-flex' }}
                >
                  <FaInfoCircle size={16} color="#07b1b0" />
                </span>
                <Tooltip
                  id="tooltip-managementStructureHeading"
                  place="right"
                  className="custom-tooltip clickable-tooltip"
                  openOnClick={true}
                  clickable={true}
                  globalCloseEvents={{ clickOutsideAnchor: true }}
                >
                  <div className="tooltip-text" dangerouslySetInnerHTML={{ __html: headingTooltip }} />
                </Tooltip>
              </>
            )}
          </div>
          <button
  type="button"
  style={{
    background: "#07b1b0",
            border: "none",
            cursor: "pointer",
            fontSize: "14px",
            color: "#fff",
            padding: "10px",
            borderRadius:"10px"
  }}
  onClick={handleGetOfficerDetails}
>
  Get Officer Detail
</button>
</div>

{/* Only when the section genuinely does not apply — Simplified AND no data saved.
    Once anything is saved here the section is required (see corporateStructureForm). */}
{isSectionSkipped("management") && (
  <div style={{
    backgroundColor: "#e7f3ff",
    border: "1px solid #b3d7ff",
    borderRadius: "8px",
    padding: "12px 16px",
    marginBottom: "20px",
    display: "flex",
    alignItems: "center",
    gap: "10px"
  }}>
    <span style={{ fontSize: "18px" }}>ℹ️</span>
    <span style={{ color: "#0066cc", fontSize: "14px" }}>
      Diligence level is <strong>Simplified</strong>. It is not required to fill out entries on this step —
      you may leave it as it is. If you do add anyone here, this section becomes required and must be
      completed and validated before the request can be signed off.
    </span>
  </div>
)}
           <div className="form-group">
        <Input
          label="Status:"
          type="text"
          name="Status"
          value={validated ? "Validated" : "Not Validated"}
          onChange="handlechange"
          disabled="true"
          isReport={isReport}
        />
      </div>
          {/* <p>Status: {validated ? "Validated" : "Not Validated"}</p> */}
          {!isReport && <SubHeadWithButton 
            heading={"Add Manager"}
            buttons={[{ buttonText: "+", onClick: ()=>{ if(!isReadOnly) addManager() }, className: "add-button", style: { backgroundColor: isReadOnly ? "#ccc" : "#07b1b0", color: "white" } }]}
          />}
          {/* // [ ] Manager Form */}
          {[...managers].reverse().map((manager, index) => (
            <MemoizedManagerForm
              renderBy={"management"}
              key={manager.id}
              index={managers.length - index}
              manager={manager}
              isReadOnly={isReadOnly}
              onRemove={()=>removeManager(manager.id)}
              onChange={(e)=>{handleChange(manager.id, e)}}
              handleIndividualChange={(e) => {handleIndividualChange(manager.id, e)}}
              handleUBOChange={(data) => handleUBOChange(manager.id, data)}
              isReport={isReport}
            />
          ))}
        </div>
         {!isReport && <RightSidebar 
      managers={managers.map((m, index) => ({ ...m, index}))}
      managerEntities={managerEntities}
      managementUboState={managers.map(manager => manager.data.uboState)}
      />}
</div>
        {!isReport && <BottomBar
          buttons={[
            { label: "Save", onClick: () => { handleSave(false) },skipConfirmation: true , disabled : validated}, // saveManagementData },
            { label: "Validate & Lock", onClick: handleValidate , disabled : validated },
            {
      label: "Back",
      onClick: handleBack,
      style: {},
      title: "Go back",
      disabled: false,
    },
            { label: "Next", onClick: handleNext }
          ]}
        />}
      </div>
     <DeleteConfirmationModal
  isOpen={isModalOpen}
  onClose={() => setIsModalOpen(false)}
  onConfirm={handleConfirmRemove}
  message="Are you sure you want to remove this manager?"
/>

       <ConfirmationModal
              isOpen={modalOpen}
              heading= {modalHeading}
              message={modalMessage}
              onClose={() => setModalOpen(false)}
            />
      {showManagerAddressModal && currentManagerIndex < managerAddressChanges.length && managerValidationResult && (
        <Modal
          modalHeading={`Address Validation - Manager ${currentManagerIndex + 1}`}
          modalMessage={
            <AddressUpdateConfirmationModal
              formData={managerAddressChanges[currentManagerIndex]?.formData}
              updatedData={managerAddressChanges[currentManagerIndex]?.updatedData}
              onContinue={managerValidationResult.handleContinue}
              onDiscard={managerValidationResult.handleDiscard}
            />
          }
          onClick={() => setShowManagerAddressModal(false)}
        />
      )}
      <FloatingQueryCenter />
      {showDetailsModal && (
  <MoreDetailsModal
    onClose={() => setShowDetailsModal(false)}
    data={modalData}
    type={modalType}
    rawData={modalRawData}
    onImport={handleImportOfficers}
  />
)}
      <ErrorModal isOpen={errorModalOpen} message={errorMessage} onClose={() => setErrorModalOpen(false)} />
    </>

  );
}
